import type { SchoolResource } from './resourceInterface';

type ResourceFilters = Record<ResourceFilterKey, ResourceFilter>;

export type ResourceFilterKey = (typeof resourceFilterKey)[keyof typeof resourceFilterKey];
export const resourceFilterKey = {
	Type: 'type',
	Audience: 'audience',
} as const;

type ResourceFilter = {
	key: ResourceFilterKey;
	name: string;
	options: Record<string, ResourceFilterOption>;
};

export interface ResourceFilterOption {
	key: ResourceFilterOptionKey;
	singularName: string;
	pluralName: string;
}

export interface ResourceAudienceOption extends ResourceFilterOption {
	color: string;
}

export type ResourceFilterOptionKey = ResourceAudienceKey | ResourceTypeKey;

export type ResourceAudienceKey = (typeof resourceAudienceKeys)[keyof typeof resourceAudienceKeys];

export const resourceAudienceKeys = {
	Teacher: 'teacher',
	Leadership: 'leadership',
	Parent: 'parent',
} as const;

export type ResourceType = {
	key: ResourceTypeKey;
	singularName: string;
	pluralName: string;
	resources: SchoolResource[];
	addYourText: string;
};

export type ResourceTypeKey = (typeof resourceTypeKeys)[keyof typeof resourceTypeKeys];

export const resourceTypeKeys = {
	Article: 'article',
	Video: 'video',
	Bot: 'bot',
	OtherStuff: 'other-stuff',
} as const;

export const resourceTypes = {
	[resourceTypeKeys.Article]: {
		key: resourceTypeKeys.Article,
		singularName: 'article',
		pluralName: 'articles',
		resources: [],
		addYourText: '',
	},
	[resourceTypeKeys.Video]: {
		key: resourceTypeKeys.Video,
		singularName: 'video',
		pluralName: 'videos',
		resources: [],
		addYourText: '',
	},
	[resourceTypeKeys.Bot]: {
		key: resourceTypeKeys.Bot,
		singularName: 'bot',
		pluralName: 'bots',
		resources: [],
		addYourText: '',
	},
	[resourceTypeKeys.OtherStuff]: {
		key: resourceTypeKeys.OtherStuff,
		singularName: 'other stuff',
		pluralName: 'other stuff',
		resources: [],
		addYourText: 'Add your first bit of Other Stuff below to get started!',
	},
};

export const resourceAudienceTeacher: ResourceAudienceOption = {
	key: resourceAudienceKeys.Teacher,
	singularName: 'teacher',
	pluralName: 'teachers',
	color: '248 141 42', // honey
};
export const resourceAudienceLeadership: ResourceAudienceOption = {
	key: resourceAudienceKeys.Leadership,
	singularName: 'leadership',
	pluralName: 'leadership',
	color: '177 32 40', // cherry
};
export const resourceAudienceParent: ResourceAudienceOption = {
	key: resourceAudienceKeys.Parent,
	singularName: 'parent',
	pluralName: 'parents',
	color: '255 92 53', // orange
};

export const audienceTypes = {
	[resourceAudienceKeys.Teacher]: resourceAudienceTeacher,
	[resourceAudienceKeys.Leadership]: resourceAudienceLeadership,
	[resourceAudienceKeys.Parent]: resourceAudienceParent,
};

export const resourceFilters: ResourceFilters = {
	[resourceFilterKey.Audience]: {
		key: resourceFilterKey.Audience,
		name: 'audience',
		options: audienceTypes,
	},
	[resourceFilterKey.Type]: {
		key: resourceFilterKey.Type,
		name: 'type',
		options: resourceTypes,
	},
};

export const getAudienceFromKey = function (key: ResourceAudienceKey) {
	if (!key) {
		return audienceTypes[resourceAudienceKeys.Teacher];
	}

	return audienceTypes[key];
};
